/**
 * 下载跳转中间页方法
 * @returns 是否是中间页
 */
const openMiddlePage = () => {
  if (window.location.href.indexOf('/h5/app/openapp') === -1) {
    const schemeUrl = `txvideo://v.qq.com/Html5Activity?url=${encodeURIComponent(window.location.href)}`;
    // openapp 页面不跳转了
    const link = `https://film.qq.com/h5/app/openapp.html?schema=${encodeURIComponent(schemeUrl)}`;
    window.location.href = link;
    return false;
  }

  return true;
};

export { openMiddlePage };
